import { AxiosInstance } from 'axios';

export type EncouragementType = 'praise' | 'encourage' | 'celebrate' | 'welcome_back' | 'greeting';

export interface GenerateMessageParams {
  progress: number;
  completedCount: number;
  totalTime: number;
  milestone?: string;
}

export default class EncouragementService {
  constructor(private axios: AxiosInstance) {}

  // 사전 정의 메시지 조회
  getMessage = async (type: EncouragementType): Promise<{ success: boolean; data: { message: string; type: string } }> => {
    const { data } = await this.axios.get('/encouragement/message', { params: { type } });
    return data;
  };

  // LLM 생성 메시지 요청
  generateMessage = async (params: GenerateMessageParams): Promise<{ success: boolean; data: { message: string } }> => {
    const { data } = await this.axios.post('/encouragement/generate', params);
    return data;
  };

  // 설정 조회
  getSettings = async (): Promise<{ success: boolean; data: { enabled: boolean } }> => {
    const { data } = await this.axios.get('/encouragement/settings');
    return data;
  };

  // 설정 저장
  updateSettings = async (enabled: boolean): Promise<{ success: boolean; data: { enabled: boolean } }> => {
    const { data } = await this.axios.put('/encouragement/settings', { enabled });
    return data;
  };
}
